<template>
  <el-config-provider :locale="locale" @mousewheel="mouseWheel" style="height: 100%;display: block">
<!--  <el-row style="height: 50px;background-color: #ffffff">-->
<!--    <el-col :span="1">-->
<!--      <el-image src="/tantu.png" lazy style="width: 50px"></el-image>-->
<!--    </el-col>-->
<!--    <el-col :span="21">-->
<!--      &lt;!&ndash;      <el-row>&ndash;&gt;-->
<!--      &lt;!&ndash;        <el-col :span="8">&ndash;&gt;-->
<!--      <h2 style="margin-top:5px;margin-left: 5px;text-align:left;font-weight: bold;font-family: 微软雅黑;font-size: 25px;color: #545c64">老油气田综合治理研究工作成果数据管理平台(二期)</h2>-->
<!--      &lt;!&ndash;        </el-col>&ndash;&gt;-->
<!--      &lt;!&ndash;        <el-col :span="16">&ndash;&gt;-->
<!--      &lt;!&ndash;        </el-col>&ndash;&gt;-->
<!--      &lt;!&ndash;      </el-row>&ndash;&gt;-->
<!--    </el-col>-->
<!--  </el-row>-->
<!--  <MainFrame msg="Welcome" />-->

        <router-view/>
  </el-config-provider>
</template>
<script>
  import zhCn from 'element-plus/lib/locale/lang/zh-cn'
//测试环境
  zhCn.el.pagination.goto="跳至";//修改分页器,文本

export default {
  name: "App",
  data() {
    return {
     locale: zhCn,
    }
  },
  methods:{
    mouseWheel(){
      this.$store.state.mouseWheel++
    }
  },
  watch: {
  }
}
</script>
<style>
/*设置全局字体样式*/
body{
  /*font-family: HarmonyOS_Sans_SC_Black;*/
  font-family: HarmonyOS_Sans_SC_Regular;
}

/*分页 样式*/
.el-pagination{
  font-size: 14px;
  color: #666;
  margin-top: 5px;
}
/*分页 选中  样式*/
.el-pagination>.el-pager>.active{
  background-color: #4499e9;
  color: #FFFFFF;
  border-radius: 4px;
}
/*下一页 样式*/
.el-pagination>.btn-next{
  padding-right: 16px;
}
/*下一页 样式*/
.el-pagination>.el-pagination__jump{
  margin-left: 6px;
}

/*!*报表内容行 鼠标悬停 样式*!*/
/*.bueatyScroll .el-table__body tr:hover > td {*/
/*  background-color: #f5f7fa !important;*/
/*}*/
/*报表内容行 鼠标悬停 样式*/
.el-table__body .hover-row > td {
  background-color: #f5f7fa !important;
}
/*!*报表内容行 鼠标点击（获得焦点） 样式*!*/
/*.bueatyScroll ::v-deep .el-table__body tr:active > td {*/
/*  background-color: #daebfb !important;*/
/*}*/
/*报表内容行 鼠标点击（获得焦点） 样式*/
.el-table__body .current-row > td {
  background-color: #daebfb !important;
}

/*报表表头行 文本内容 样式*/
.el-table__header .cell{
  padding-left: 8px;
  padding-right: 8px;
}
/*报表表头行 排序箭头 样式*/
.el-table__header .caret-wrapper {
  float: right;
  margin-top: 5px;
}

/*报表空数据 设置背景图，并居中  的样式*/
.el-table__empty-block {
  width: 100% !important;
  margin: auto;
  height: 100%!important;
  min-height: 300px!important;
  line-height: 300px !important;
  box-sizing: border-box;
  background: url('../public/table_zwsj.png') no-repeat 50% 42%;
}
/*报表空数据 文本样式*/
.el-table__empty-text {
  font-size: 14px;
  color: #666;
}
</style>
<style scoped>
/*取消button按钮之间的左边距*/
/deep/.el-button+.el-button, .el-checkbox.is-bordered+.el-checkbox.is-bordered{
  margin-left: 0px;
}
/*设置全局button按钮（删除） 默认样式*/
/deep/.el-button--danger{
  margin-left: 0px;
  margin-right: 12px;
  border-radius: 4px;
  height: 28px;
}
/*设置全局button按钮（取消） 默认样式*/
/deep/.el-button--default{
  margin-left: 0px;
  margin-right: 12px;
  border-radius: 4px;
  height: 28px;
}
/*设置全局button按钮（primary） 默认样式*/
/deep/.el-button--primary{
  background-color: #4499e9;
  border-color: #4499e9;
  margin-left: 0px;
  margin-right: 12px;
  border-radius: 4px;
  height: 28px;
  /*font-size: 14px;*/
  color: #FFFFFF;
}
/*设置全局button按钮（primary） 移入样式*/
/deep/ .el-button--primary:hover{
  background-color: #60a8ec;
  border-color: #60a8ec;
}
/*设置全局button按钮（primary） 选中样式*/
/deep/ .el-button--primary:active{
  background-color: #2f76c2;
  border-color: #2f76c2;
}

/*设置全局dropdown按钮  默认样式*/
/deep/.el-dropdown{
  /*background-color: #4499e9;*/
  /*border-color: #4499e9;*/
  /*margin-left: 0px;*/
  margin-right: 12px;
  /*margin-bottom: 20px;*/
}
/*设置全局dropdown按钮下的button按钮  默认样式*/
/deep/.el-dropdown__caret-button{
  margin-right: 0px;
}
</style>

